import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  // Analytics are collected on production only
  private readonly enabled = environment.production;

  constructor() { }

  public initAmplitude(userEmail: string) {
    if (!this.enabled) {
      return;
    }

    const sessionReplayTracking = sessionReplayPlugin();
    amplitude.add(sessionReplayTracking);

    amplitude.init('d9975e56e53d0bd91d490b2f8cae1bec', userEmail, {
      defaultTracking: true,
      autocapture: true,
      fetchRemoteConfig: true,
      deviceId: amplitude.getDeviceId(),
    });
  }

  public trackEvent(eventName: string, eventData?: any) {
    if (!this.enabled) {
      return;
    }

    amplitude.track(eventName, eventData);
  }
}
